import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [ "rangeSelected", "statusSelected", "loader", "dataRow"]

    connect() {
        this.fetchNodeStatsData();
    }

    rangeSelected(event) {
        event.preventDefault()
        this.rangeSelectedTarget.innerHTML = event.currentTarget.innerHTML;
        var current = event.currentTarget.dataset.range;
        this.rangeSelectedTarget.dataset.current = current;

        this.fetchNodeStatsData();
    }

    statusSelected(event) {
        event.preventDefault()
        this.statusSelectedTarget.innerHTML = event.currentTarget.innerHTML;
        var current = event.currentTarget.dataset.status;
        this.statusSelectedTarget.dataset.current = current;

        this.fetchNodeStatsData();
    }

    fetchNodeStatsData() {
        let rangeStr = this.rangeSelectedTarget.dataset.current;
        let range = rangeStr.split("~");
        let start_date = range[0];
        let end_date = range[1];
        var status = this.statusSelectedTarget.dataset.current;

        $(this.loaderTarget).show()
        const nodeStatUrl = this.data.get("url")
        const that = this
        $.ajax({
            method: "GET",
            url: nodeStatUrl,
            data: {
                start_date: start_date,
                end_date: end_date,
                status: status
            }
        }).done(function(result) {
            $(that.loaderTarget).hide()
            let result_html = "";
            result.forEach((line) => {
                result_html += `<tr><td><a href="${line.user_url}">${line.email}</a></td><td>${line.name}</td><td>${line.bandwidth}</td><td>${line.node_count}</td></tr>`
            })
            that.dataRowTarget.innerHTML = result_html
        })
    }
}